import { MyOrganizationKey } from "./key";
import { SimpleQueryOptions, useBaseQuery } from "../baseQuery";
import { GetMyOrganizationsResponse } from "@maven-rest/docs/Organization.dto";
import { OrganizationUrl } from "@maven-rest/docs/Organization.url";

export function useMyOrganizationsQuery(options?: SimpleQueryOptions<GetMyOrganizationsResponse>) {
  return useBaseQuery({
    queryKey: [MyOrganizationKey.MyOrganizations],
    fnOption: {
      url: OrganizationUrl.getMyOrganizations,
    },
    ...options,
  });
}
